import { BaseModel } from '../models/BaseModel'

export const ConfigModel = BaseModel.named('Config').props({
  orderListSoundIntervalSec: 60, // TODO move this static value to some config file & delete this model maybe?
})
